import React from 'react'

function HomePageMidBodySection({solutions}) {
  return (
    <div ref={solutions} className='HomePageMidBodySection'>
        <h2>Why Choose Fashioniste?</h2>
        <div className="services-section">
            <div className="services-card">
              <h3>📸 Daily Outfit Capture</h3>
              <p className='greyText'>Document your daily looks and build your personal style archive</p>
            </div>
           
            <div className="services-card">
              <h3>💡 Style Inspiration</h3>
              <p className='greyText'>Discover new trends and get inspired by fashion enthusiasts</p>
            </div>
            <div className="services-card">
              <h3>👥 Fashion Community</h3>
              <p className='greyText'>Connect with others who share your passion for fashion</p>
            </div>
        </div>
    </div>
  )
}

export default HomePageMidBodySection